<template>
  <!-- banner下面公告 -->
    <div class="import-news">
      <div class="container">
        <swiper ref="newsSwiper"  :options="options" v-if="newsList && newsList.length>0">
          <swiper-slide v-for="item in newsList">
            <div class="item">
              <div class="item-time">{{item.pub_time}}</div>
              <div class="item-txt">
                <router-link :to="{path:'/news/'+item.id,params:{id:item.id}}">
                  <p>{{item.title}}</p>
                  <span class="iconfont icon-HOT" v-if="item.news_type==2"></span>
                  <span class="iconfont icon-new" v-if="item.news_type==1"></span>
                </router-link>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
</template>

<script>

import{swiper,swiperSlide} from "vue-awesome-swiper"
export default {
  name: 'Footer',
  components:{swiper,swiperSlide},
  props: {
    msg: String
  },
  data(){
    return{
      options:{
         direction: 'vertical',
         spaceBetween: 3,
        slidesPerView: 2,
        autoplay:{
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        observer:true,
        observeParents:true,
        loop: true
      },
      swiperFlag:true,
      newsList:[],
      newsSwiper: null,
    }
  },
  methods:{
    _getNewslist(){
      let params={
        page:1,
        pageSize:6,
        recommend:1
      }
      this.$api.newsApi.getList(params).then(res=>{
        this.newsList = res.data;
        this.initSwiper()
      })
    },
    initSwiper() {
      const _t = this
      if (this.$refs.newsSwiper) {
        this.newsSwiper = this.$refs.newsSwiper.swiper
        this.newsSwiper.init()
      } else {
        setTimeout(() => {
          _t.initSwiper()
        }, 100)
      }
    },
  },
  mounted(){
    this._getNewslist();
  }
}
</script>